import { Component, Input } from '@angular/core';

@Component({
  selector: 'bs-project-icon',
  imports: [],
  template: `
  <svg id="project-icon" [style.width.px]="width" [style.height.px]="height" [style.fill]="iconFill" [style.stroke]="iconFill" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
    <path d="M61.99,28.596v-6.958c0-1.988-1.612-3.6-3.6-3.6h-24.35c-.559,0-1.11-.13-1.61-.38l-12.88-6.44c-.5-.25-1.051-.38-1.61-.38H7.99c-1.988,0-3.6,1.612-3.6,3.6v43.2" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <path d="M64.009,28.761H13.751c-1.716,0-3.194,1.09-3.53,2.605l-5.76,25.92c-.446,2.005,1.258,3.875,3.53,3.875h50.257c1.716,0,3.194-1.09,3.53-2.605l5.76-25.92c.446-2.005-1.258-3.875-3.53-3.875Z" style="fill: none; stroke-miterlimit: 10; stroke-width: 3px;"/>
  </svg>
  `,
  styles: `
`,
  standalone: true
})
export class BsProjectIconComponent {
  @Input() width: number = 30;
  @Input() height: number = 30;
  @Input() iconFill: string = 'var(--p-bs-icon-color)';
}
